import React, { Component } from "react";
import { useParams } from "react-router-dom";
import BookData from "../data/book-data";

class BookDetail extends Component {
  render() {
    return this.props.book.map((book) => (
      <div className="book-details">
        <h3 className="book-title">{book.title}</h3>
        <div class="break"></div>
        <img
          src={require(`../data/images/${book.imageUrl}`).default}
          className="book-detail-img"
          alt={book.title}
        />
        <div class="break"></div>
        <div className="book-author">Author: {book.author}</div>
        <div class="break"></div>
        <div className="pages">Number of Pages: {book.pages}</div>
        <div class="break"></div>
        <div className="book-description">{book.description}</div>
      </div>
    ));
  }
}

function BookDetailFunc() {
  let params = useParams();
  const data = new BookData().getBookById(params.id);

  return <BookDetail id={params.id} book={data} />;
}

export default BookDetailFunc;
